import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, ArrowUpRight, Star } from "lucide-react";
import { IMAGES, SOCIAL } from "../data/site";

export const Footer = () => (
  <footer className="border-t border-border bg-surface" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
      <div className="grid gap-16 md:grid-cols-12">
        <div className="md:col-span-6">
          <img
            src={IMAGES.logo}
            alt="Desert Vibe Media"
            className="mb-8 h-24 w-auto object-contain"
          />
          <h2 className="mt-2 font-display text-5xl leading-[0.95] text-sand-100 md:text-7xl">
            Your story is <span className="italic text-sand-700">our business.</span>
          </h2>
          <Link to="/contact" className="mt-10 inline-flex">
            <span className="btn-desert" data-testid="footer-cta">
              Begin the conversation <ArrowUpRight size={16} />
            </span>
          </Link>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-sand-400">Explore</p>
          <ul className="mt-6 space-y-3">
            {["Services", "Portfolio", "About", "Contact"].map((x) => (
              <li key={x}>
                <Link
                  to={`/${x.toLowerCase()}`}
                  className="font-body text-lg text-sand-100 link-underline"
                  data-testid={`footer-link-${x.toLowerCase()}`}
                >
                  {x}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-sand-400">Reach us</p>
          <a
            href="mailto:Info@desertvibemedia.com"
            className="mt-6 flex items-center gap-2 text-sand-100 link-underline"
            data-testid="footer-email"
          >
            <Mail size={16} /> Info@desertvibemedia.com
          </a>
          <div className="mt-6 flex gap-5 text-sand-400">
            <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="hover:text-sand-700 transition-colors"><Instagram size={20} /></a>
            <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="hover:text-sand-700 transition-colors"><Facebook size={20} /></a>
          </div>
          <a
            href={SOCIAL.googleReview}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-google-review"
            className="mt-8 inline-flex items-center gap-2 border border-border px-4 py-3 overline text-sand-100 transition-colors hover:border-sand-700 hover:text-sand-700"
          >
            <Star size={14} fill="currentColor" /> Leave a Google review
          </a>
        </div>
      </div>

      <div className="mt-16 flex flex-col justify-between gap-4 border-t border-border pt-8 text-sand-400 md:flex-row">
        <p className="text-sm">&copy; {new Date().getFullYear()} Desert Vibe Media. All rights reserved.</p>
        <p className="text-sm">Shot in the desert. Delivered worldwide.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
